/**
 * frontend/src/services/exportacionBeneficios/exportacionBeneficiosService.js
 *
 * Servicio HTTP para consumir la API de exportación de beneficios.
 */

import axios from 'axios';
import config from '../../config';

const API_BASE = `${config.baseUrl}/api/exportacion-beneficios`;

function construirParams(filtros) {
  const params = new URLSearchParams();
  params.append('numeroEntrega', filtros.numeroEntrega);
  if (filtros.municipio_oid) params.append('municipio_oid', filtros.municipio_oid);
  if (filtros.usuarioRIT) params.append('usuarioRIT', filtros.usuarioRIT);
  return params;
}

/**
 * Vista previa de los datos (Sujetos + Recolectores) a exportar.
 */
export const obtenerDatos = async (filtros) => {
  const response = await axios.get(`${API_BASE}/datos?${construirParams(filtros)}`);
  return response.data;
};

/**
 * Catálogos de filtros (municipios y usuarios RIT) disponibles para la entrega.
 */
export const obtenerCatalogos = async (numeroEntrega, municipio_oid) => {
  const params = new URLSearchParams();
  params.append('numeroEntrega', numeroEntrega);
  if (municipio_oid) params.append('municipio_oid', municipio_oid);

  const response = await axios.get(`${API_BASE}/catalogos?${params}`);
  return response.data;
};

/**
 * Descarga el Excel oficial (plantilla real diligenciada por el backend).
 * Devuelve { blob, nombreArchivo } listo para guardar con file-saver.
 */
export const descargarExcel = async (filtros) => {
  const response = await axios.get(`${API_BASE}/exportar?${construirParams(filtros)}`, {
    responseType: 'blob',
  });

  const disposition = response.headers['content-disposition'] || '';
  const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
  const nombreArchivo = match ? decodeURIComponent(match[1]) : `Beneficios_Entrega${filtros.numeroEntrega}.xlsx`;

  return { blob: response.data, nombreArchivo };
};

/**
 * Health check.
 */
export const health = async () => {
  const response = await axios.get(`${API_BASE}/health`);
  return response.data;
};
